<template>
  <div class="countdown">
    <span class="countdown-title">{{ title }}</span>
    <div class="countdown-time">
      <div class="time-block"><span>{{ time.hours }}</span></div>
      <div class="colon">:</div>
      <div class="time-block"><span>{{ time.minutes }}</span></div>
      <div class="colon">:</div>
      <div class="time-block"><span>{{ time.seconds }}</span></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, reactive } from 'vue'

interface Props {
  title?: string
  duration: number // 倒计时时长（秒）
}

const props = defineProps<Props>()

// 时间数据
const time = reactive({
  hours: '00',
  minutes: '00',
  seconds: '00'
})

let timer: NodeJS.Timer | null = null
let remain = props.duration // 剩余秒数

// 格式化数字
function format(num: number) {
  return num < 10 ? `0${num}` : `${num}`
}

function updateCountdown() {
  if (remain <= 0) {
    if (timer) {
      clearInterval(timer)
      timer = null
    }
    return
  }

  const hours = Math.floor(remain / 3600)
  const minutes = Math.floor((remain % 3600) / 60)
  const seconds = remain % 60

  time.hours = format(hours)
  time.minutes = format(minutes)
  time.seconds = format(seconds)

  remain--
}

onMounted(() => {
  updateCountdown()
  timer = setInterval(updateCountdown, 1000)
})

onUnmounted(() => {
  if (timer) clearInterval(timer)
})
</script>

<style scoped lang="scss">
.countdown {
  display: flex;
  align-items: center;
  font-family: SFPro, sans-serif;
  font-size: 14px;
  color: #222;

  .countdown-title {
    margin-right: 6px;
    font-family: 'SFPro', 'SFPro';
    font-weight: 500;
    font-size: 14px;
    color: #32343A;
    line-height: 16px;
    font-style: normal;
  }

  .countdown-time {
    display: flex;
    align-items: center; /* 时分秒块垂直居中 */
    justify-content: center; /* 时分秒块水平居中 */

    .time-block {
      background: #000;
      color: #fff;
      padding: 2px 0;
      border-radius: 4px;
      font-weight: 600;
      min-width: 24px;
      display: flex;
      align-items: center; /* 数字在 time-block 内垂直居中 */
      justify-content: center; /* 数字在 time-block 内水平居中 */
      text-align: center;
      font-size: 14px;
      font-family: D-DIN-PRO, D-DIN-PRO;

      span {
        transform: translateY(0.5px); /* 手动下调 2px，修正 D-DIN-PRO 字体基线偏上 */
      }
    }

    .colon {
      margin: 0 4px;
      font-weight: bold;
    }
  }
}
</style>
